import { ManquementConstate } from './manquement-constate.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class PointAMaitriser {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        manquementsConstates: { key: 'manquementsConstates', converter: new (ArrayClassConverterFactory.build(ManquementConstate))(), optional: true }
    };

    id: number;
    code: string;
    libelle: string;
    manquementsConstates: ManquementConstate[];
}
